import { getCookieConsentValue } from "react-cookie-consent";

let ReactPixel: any;
if (typeof window === "undefined") {
  ReactPixel = null;
} else {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  ReactPixel = require("react-facebook-pixel").default;
}

export const pixelInit = (): void => {
  if (ReactPixel) {
    ReactPixel.init("460630345218830", null, {
      autoConfig: true,
      debug: false,
    });
    if (!getCookieConsentValue()) {
      ReactPixel.revokeConsent();
    }
  }
};

export const pixelTrackRegister = (): void => {
  if (ReactPixel) {
    ReactPixel.track("CompleteRegistration", {
      content_name: "Course",
    });
  }
};

export const pixelTrackPage = (): void => {
  if (ReactPixel) {
    ReactPixel.pageView();
  }
};

export const pixelTrackPlayLecture = (): void => {
  if (ReactPixel) {
    ReactPixel.trackCustom("PlayLecture");
  }
};

export const pixelTrackQuiz = (question: string, answer: string): void => {
  if (ReactPixel) {
    ReactPixel.trackCustom("Quiz", { question, answer });
  }
};

export const pixelTrackContact = (): void => {
  if (ReactPixel) {
    ReactPixel.trackCustom("Contact");
  }
};

export const pixelGrantConsent = (): void => {
  if (ReactPixel) {
    ReactPixel.grantConsent();
  }
};
